export default __webpack_public_path__ + "static/media/hoikhi.2a8c26e7.png";